import { AnyAction } from 'redux';
import { Category, SupplierMapping } from '@synergy/models';

import {
    CLEAR_SUPPLIER_CATEGORY_MAPPINGS,
    RECEIVE_SUPPLIER_CATEGORY_MAPPING,
    RECEIVE_SUPPLIER_CATEGORY_MAPPINGS,
} from './supplier-category-mapping-actions';

export interface SupplierCategoryMappingReducerState {
    supplierMappings: SupplierMapping<Category>[] | null;
}

export const initialCategoryState: SupplierCategoryMappingReducerState = {
    supplierMappings: null,
};

export const supplierCategoryMappingReducer = (
    state: SupplierCategoryMappingReducerState = initialCategoryState,
    action: AnyAction
): SupplierCategoryMappingReducerState => {
    const { type, ...rest } = action;

    switch (type) {
        case RECEIVE_SUPPLIER_CATEGORY_MAPPING: {
            const supplierMappings = [...(state.supplierMappings ?? [])];
            const index = supplierMappings.findIndex(mapping => mapping.id === rest['supplierMapping'].id);
            if (index >= 0) {
                supplierMappings[index] = rest['supplierMapping'];
            }
            return {
                ...state,
                supplierMappings,
            };
        }

        case RECEIVE_SUPPLIER_CATEGORY_MAPPINGS: {
            return {
                ...state,
                supplierMappings: rest['supplierMappings'],
            };
        }

        case CLEAR_SUPPLIER_CATEGORY_MAPPINGS: {
            return {
                ...state,
                supplierMappings: [],
            };
        }

        default: {
            return state;
        }
    }
};
